// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__LANtY","signatureButtonsRight":"ModalSign_signatureButtonsRight__1aXSI"};